import { mapActions, mapGetters, mapState } from 'vuex';
import { isMarketDisabled, contractOwnershipNum } from '@/utils/helpers';
import { sumBy } from 'lodash';

const firstNonEmptyString = (...values) => values.find(
  (value) => typeof value === 'string' && value.trim() !== '',
);

export default {
  props: {
    market: {
      type: Object,
      required: true
    },
    forCmsWidget: {
      type: Boolean,
      default: false,
    },
    forceMobileLayout: {
      type: Boolean,
      default: false,
    },
    dontShowOdds: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('app', ['isTradingEnabled', 'isLayoutMobile', 'oddsModeEnabled']),
    ...mapState('app', ['showOdds']),
    useMobileLayout() {
      return this.forceMobileLayout || this.isLayoutMobile;
    },
    hasOwnership() {
      if (this.market === null || !this.isLoggedIn) return false;
      return sumBy(this.market.contracts, i => contractOwnershipNum(i)) > 0;
    },
    isMarketDisabled() {
      return this.market !== null && isMarketDisabled(this.market);
    },
    pricesTitle() {
      return this.isLayoutMobile ? 'Trade Prices' : 'Last Trade Price';
    },
    titleSecond() {
      if (this.dontShowOdds) {
        return this.pricesTitle;
      }
      return this.showOdds ? 'Odds' : this.pricesTitle;
    },
    titleFirst() {
      if (!this.forCmsWidget) {
        return 'Contract';
      }

      return firstNonEmptyString(
        this.market && this.market.marketShortName,
        this.market && this.market.marketName,
      ) || 'Contract';
    },
    titleThird() {
      return this.forCmsWidget ? 'Volume' : 'Ownership';
    },
    titleFourth() {
      return 'Outcome';
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    ...mapActions('app', ['setShowOdds']),
    onMenuToggle() {
      this.showMenu = !this.showMenu;
    },
    onClickOutside() {
      this.showMenu = false;
    },
    setOddsMode(value) {
      this.setShowOdds(value);
      this.showMenu = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-contracts-list-header-sushi/market-contracts-list-header-sushi.js